import { useNavigate, useLocation } from 'react-router-dom';
import { CalendarDays, Sparkles } from 'lucide-react';

/**
 * Sub-navigation strip used at the top of the Events screens.
 * Click between the Pro Tour Schedule (/schedule) and Personal Events (/personal-events).
 */
export function EventsSubNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const isPersonal = location.pathname.startsWith('/personal-events');

  const tabs = [
    { path: '/schedule', label: 'Pro Tour Schedule', icon: CalendarDays, active: !isPersonal },
    { path: '/personal-events', label: 'Personal Events', icon: Sparkles, active: isPersonal },
  ];

  return (
    <div
      className="flex items-center gap-1 border-b border-white/10 mb-6 overflow-x-auto"
      data-testid="events-subnav"
    >
      {tabs.map(({ path, label, icon: Icon, active }) => (
        <button
          key={path}
          onClick={() => navigate(path)}
          className={`flex items-center gap-2 px-4 py-3 text-sm font-medium transition-colors border-b-2 -mb-px whitespace-nowrap ${
            active
              ? 'text-white border-primary'
              : 'text-muted-foreground border-transparent hover:text-white'
          }`}
          data-testid={`events-subnav-${path === '/schedule' ? 'pro-tour' : 'personal'}`}
        >
          <Icon className="w-4 h-4" />
          {label}
        </button>
      ))}
    </div>
  );
}

export default EventsSubNav;
